module.exports = __webpack_public_path__ + "static/media/Barlow-Bold.21468efd.ttf";